var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var SocialSecurityDataService = /** @class */ (function () {
    function SocialSecurityDataService() {
    }
    /**
     * 社保资料查询
     */
    SocialSecurityDataService.prototype.search = function (data, page, sort, loading) {
        return this.netService.send({
            server: repairService.socialSecurityDataController.search,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 社保资料创建
     */
    SocialSecurityDataService.prototype.insert = function (data, loading) {
        return this.netService.send({
            server: repairService.socialSecurityDataController.insert,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除社保资料
     */
    SocialSecurityDataService.prototype.delete = function (data, loading) {
        return this.netService.send({
            server: repairService.socialSecurityDataController.delete,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改社保资料
     */
    SocialSecurityDataService.prototype.update = function (data, loading) {
        return this.netService.send({
            server: repairService.socialSecurityDataController.update,
            data: data,
            loading: loading
        });
    };
    /**
     * 按导入批次删除户籍资料
     */
    SocialSecurityDataService.prototype.deleteByBatch = function (batchNumber, loading) {
        return this.netService.send({
            server: repairService.socialSecurityDataController.deleteByBatch,
            data: {
                batchNumber: batchNumber
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], SocialSecurityDataService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SocialSecurityDataService.prototype, "search", null);
    return SocialSecurityDataService;
}());
export { SocialSecurityDataService };
